import { useState } from "react";
import { DateTimeDisplay, Breadcrumbs, StatusMessage } from "../../components/ui";
import LoadingSpinner from "../../components/ui/LoadingSpinner";
import { useAuth0 } from "../../contexts/useAuthContext";
import { useBreadcrumbs } from "../../hooks/useBreadcrumbs";
import DetailedAlarmCharts from "../../components/charts/charts/DetailedAlarmCharts";
import { DashboardOverview } from "../../features/dashboard/DashboardOverview";
import { useDashboardFilters } from "../../features/dashboard/useDashboardFilters";

const Dashboard = () => {
    const { isAuthenticated, isLoading } = useAuth0();
    const filters = useDashboardFilters(isAuthenticated && !isLoading);
    const [activeTab, setActiveTab] = useState<"bureau" | "stats">("bureau");
    const breadcrumbs = useBreadcrumbs({ currentPageTitle: "Dashboard" });
    if (isLoading) {return <LoadingSpinner message="Loading…" fullHeight />;}
    if (!isAuthenticated) {return <div>You are not logged in. Please log in to view this content.</div>;}
    return (
        <main><div className="container mb-2">
            <section className="page">
                <div className="heading__row">
                    <div>
                        <h2 className="heading__title heading__title--dashboard">Dashboard - {activeTab === "stats" ? "Alarm Stats" : "CSH Alarms"}</h2>
                        <DateTimeDisplay /><Breadcrumbs items={breadcrumbs} />
                    </div>
                    <div role="tablist" aria-label="Dashboard view" className="tabs">
                        {([["bureau", "CSH Alarms"], ["stats", "Alarm Stats"]] as const).map(([key, label]) => (
                            <button key={key} type="button" role="tab" aria-selected={activeTab === key}
                                onClick={() => setActiveTab(key)} className={`tabs__tab${activeTab === key ? " tabs__tab--active" : ""}`}>{label}</button>
                        ))}
                    </div>
                </div>
                {filters.error && <StatusMessage kind="error">{filters.error}</StatusMessage>}
                {activeTab === "stats" ? <DetailedAlarmCharts /> : <DashboardOverview
                    searchQuery={filters.searchQuery} category={filters.category}
                    onSearchChange={filters.setSearchQuery} onCategoryChange={filters.setCategory} />}
            </section>
        </div></main>
    );
};

export default Dashboard;
